<app-adminmenu *ngIf="desosuserinfo.blnIsAdmin"></app-adminmenu>
<app-usersmenu *ngIf="desosuserinfo.blnIsDESOSManager"></app-usersmenu>
<app-usersmenu *ngIf="desosuserinfo.blnIsUser"></app-usersmenu>
<div class="bg-light shadow-lg">
  <div class="input-group-prepend p-2" mat-raised-button color="primary">
    <button mat-raised-button color="primary" *ngIf="(desosreportinfo.mm === 'NO' ? false:true)" (click)="btnNewOutcome()">New Record and Outcome</button>
  </div>
  <mat-card class="main-card p-3">
    <mat-accordion class="example-headers-align" multi="true" displayMode="flat">
      <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Current Records Search
          </mat-panel-title>
          <mat-panel-description>
            Records Search by record number, date of birth, name, program, county, city, race, gender etc..
            <mat-icon>search</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-admin-search (nextStep)="searchCurrentList($event)"></app-admin-search>
        <mat-action-row>
          <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
        </mat-action-row>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Current List
          </mat-panel-title>
          <mat-panel-description>
            Searched Current List
            <mat-icon>list_alt</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-current-list></app-current-list>
        <mat-action-row>
          <button mat-raised-button color="primary" (click)="prevStep()">Search</button>
          <!--<button mat-raised-button color="primary" (click)="nextStep()">Next</button>-->
        </mat-action-row>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Archive Records Search
          </mat-panel-title>
          <mat-panel-description>
            Records Search by name, program, date of birth, race, gender etc..
            <mat-icon>search</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-archive-search (nextStep)="searchArchiveList($event)"></app-archive-search>
        <mat-action-row>
          <button mat-raised-button color="primary" (click)="nextStep()">Next</button>
        </mat-action-row>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Archive List
          </mat-panel-title>
          <mat-panel-description>
            Searched Archive List
            <mat-icon>archive</mat-icon>
          </mat-panel-description>
        </mat-expansion-panel-header>
        <app-archive-list></app-archive-list>
        <mat-action-row>
          <button mat-raised-button color="primary" (click)="prevStep()">Search</button>
          <!--<button mat-raised-button color="primary" (click)="nextStep()">Next</button>-->
        </mat-action-row>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card>
</div>
<app-footer></app-footer>



